import { Component, Inject, OnDestroy, OnInit } from '@angular/core';
import { DomSanitizer, SafeUrl } from '@angular/platform-browser';

import { ApplicationFacade } from '@ridango/components';
import { CoreFacade, Language } from '@ridango/core';

import { combineLatest, Observable, Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';

@Component({
    selector: 'rwidget-privacy',
    templateUrl: './privacy.component.html'
})
export class PrivacyComponent implements OnInit, OnDestroy {
    private componentDestroyed$ = new Subject<void>();

    privacyUrl: SafeUrl;
    highContast$: Observable<boolean> = this.applicationFacade.highContrast$;
    selectedLanguage$: Observable<Language> = this.coreFacade.selectedLanguage$;

    constructor(
        private applicationFacade: ApplicationFacade,
        public sanitizer: DomSanitizer,
        @Inject('ENV') private env: any,
        private coreFacade: CoreFacade
    ) {}

    ngOnInit() {
        combineLatest([this.selectedLanguage$, this.highContast$])
            .pipe(takeUntil(this.componentDestroyed$))
            .subscribe(([language, highContrast]) => {
                const url = `${this.env.STATIC_CONTENT_BASE_URL}/${this.env.REGION_ID}/web/privacy/${language.code}/`;
                this.privacyUrl = this.sanitizer.bypassSecurityTrustResourceUrl(
                    highContrast ? `${url}#high-contrast` : url
                );
            });
    }

    ngOnDestroy() {
        this.componentDestroyed$.next();
        this.componentDestroyed$.complete();
    }
}
